module.controller('userListCtrl', [ '$scope', '$rootScope', '$state', '$window', 'userService', 'alertService', 'roleService', 'parameterService',
		function($scope, $rootScope, $state, $window, userService, alertService, roleService, parameterService) {

			$scope.filter = {
				visible : true
			};
			$scope.users = [];
			$scope.loading = false;
			$scope.pagination = {
				current : 1,
				total : 0
			};

			$scope.started = false;

			$scope.asignUserAsLegalRep = function(user) {

				alertService.showSwtQuestion('Asignar representante legal', function() {
					$scope.loading = true;

					var id = user.id;
					user.legalRep = false;

					userService.asignUserAsLegalRep(id).then(function(response) {

						$scope.loading = false;

						$scope.users.forEach(function(user) {
							if (user.legalRep == true) {
								user.legalRep = false;
							}
						});

						user.legalRep = true;
						alertService.showSuccess('Representante legal asignado exitosamente');

					}, function(response) {
						$scope.loading = false;
					});
				});
			};

			/**
			 * 
			 * @param page
			 */
			$scope.search = function(page) {
				$scope.loading = true;

				page = page == undefined ? 1 : page;
				$scope.pagination.current = page;

				var filter = {};
				filter.offset = (page - 1) * $rootScope.pageSize;
				filter.limit = $rootScope.pageSize;
				filter.visible = $scope.filter.visible;

				if ($scope.filter.name) {
					filter.name = $scope.filter.name;
				}

				if ($scope.filter.username) {
					filter.username = $scope.filter.username;
				}

				userService.searchUsers(filter).then(function(response) {
					$scope.loading = false;
					var result = response.getData();

					$scope.users = result.results;
					$scope.pagination.total = result.totalRegisters;

				}, function(response) {
					$scope.loading = false;
				});
			};

			/**
			 * 
			 */
			$scope.clearFilters = function() {
				$scope.filter = {};
			};

			$scope.changeUserState = function(user, state) {
				userService.modifyUserStatus(user.id, state).then(function(response) {
					$scope.loading = false;
					alertService.showSuccess("cambio de estado exitoso");
				}, function(response) {
					user.enable = !state;
					$scope.loading = false;
				});
			};

			$scope.search(1);

		} ]);
